import React from 'react';
import {
  hidePaymentGatewayError,
  pageRequest,
  setOpenInformationModal,
  showCloneOutletProgress,
  setCloneSuccess,
} from 'actions/outletPages/list';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import { askConfirmAction } from 'actions/confirm-action';
import { push } from 'react-router-redux';
import { getFormValues, isDirty } from 'redux-form';
import ConfirmActionModal from 'components/ConfirmActionModal';
import {
  ContentWrapper,
  LeftColumnWrapper,
  PageWrapper,
  RightColumnWrapper,
} from 'components/wrappers/pages';
import NoDataAndLoading from 'components/NoDataAndLoading';
import PaymentGatewayErrorModal from 'components/PaymentGatewayErrorModal';
import withFeatureFlag from 'hocs/withFeatureFlags';
import { PUSHER_APP_KEY } from 'api/constants';
import Pusher from 'pusher-js';
import AddOutletModal from './AddOutletModal';
import ReactivateOutletModal from './ConfirmReactivateOutletModal';
import OutletDetail from './OutletDetail';
import Table from './Table';
import ActionBar from './ActionBar';
import ReactiveOutletWithoutPayModal from './ReactiveOutletWithoutPayModal';
import PaymentMethodModal from './PaymentMethodModal';
import CloneOutletModal from './OutletDetail/CloneOutletModal/CloneOutletModal';

class List extends React.Component {
  componentDidMount() {
    const { billingNotification, hasCloneOutletFeatureFlag } = this.props;
    this.props.dispatch(
      pageRequest(billingNotification, hasCloneOutletFeatureFlag)
    );
    browserHistory.listenBefore(location => {
      if (
        this.props.data.isDirtyForm &&
        this.props.data.confirmAction.nextAction === null &&
        (this.props.cloneResult === null || !this.props.cloneResult.success)
      ) {
        // negate the change location, instead use sagas to handle the change location
        this.props.dispatch(askConfirmAction(push(location.pathname)));
        return false;
      }
    });

    const { businessId } = this.props;
    const pusher = new Pusher(PUSHER_APP_KEY, {
      cluster: 'ap1',
      encrypted: true,
    });
    this.channel = pusher.subscribe(`moka-${businessId}-inventory`);
  }

  componentDidUpdate() {
    const { cloneOutletSubmit } = this.props;
    if (this.channel) {
      this.channel.unbind();
    }
    this.channel.bind('outlet/clone', data => {
      if (
        data.success !== null &&
        data.success !== undefined &&
        (!cloneOutletSubmit ||
          cloneOutletSubmit.destination_outlet_id === data.destination_clone_id)
      ) {
        const outlet = {};
        outlet.source_clone_id = Number(data.source_clone_id);
        outlet.destination_outlet_id = Number(data.destination_clone_id);
        outlet.source_clone_name = data.source_clone_name;
        outlet.destination_outlet_name = data.destination_clone_name;
        this.props.dispatch(showCloneOutletProgress(outlet));
        if (data.success === true) {
          this.props.dispatch(setCloneSuccess(outlet));
        }
      }
    });
  }

  componentWillUnmount() {
    if (this.channel) {
      this.channel.unbind();
    }
  }

  render() {
    const {
      outlets,
      outletDetail,
      openRightColumn,
      profile,
      hasCloneOutletFeatureFlag,
    } = this.props.data.outletPages.list;
    const { showLoadingSpinnerPage } = this.props.data.loadingSpinner;
    const {
      outletCount,
      outletPrice,
      showPaymentGatewayErrorModal,
    } = this.props.data;

    return (
      <PageWrapper>
        <ActionBar dispatch={this.props.dispatch} />
        <ContentWrapper>
          <LeftColumnWrapper openRightColumn={openRightColumn}>
            <NoDataAndLoading
              showLoadingSpinner={showLoadingSpinnerPage}
              noDataToDisplay={outlets.length === 0}
              title="No Data To Display"
              description=""
            />
            <Table
              outlets={outlets}
              dispatch={this.props.dispatch}
              outletDetail={outletDetail}
              isDirtyForm={this.props.data.isDirtyForm}
              loggedInEmail={profile && profile.email}
            />
          </LeftColumnWrapper>
          <RightColumnWrapper openRightColumn={openRightColumn}>
            <OutletDetail
              outlet={outletDetail}
              dispatch={this.props.dispatch}
              outlets={outlets}
              loggedInEmail={profile && profile.email}
            />
          </RightColumnWrapper>
        </ContentWrapper>
        <ConfirmActionModal />
        <ReactivateOutletModal />
        <ReactiveOutletWithoutPayModal />
        <AddOutletModal />
        {hasCloneOutletFeatureFlag && (
          <PaymentMethodModal
            handleClose={() => {
              this.props.dispatch(setOpenInformationModal(false));
            }}
          />
        )}
        {outletPrice && outletCount && (
          <PaymentGatewayErrorModal
            totalPrice={(
              outletPrice.final_price * parseInt(outletCount.countOutlet)
            ).toString()}
            showModal={showPaymentGatewayErrorModal}
            onHide={() => {
              this._onHideModal();
            }}
          />
        )}
        {this.props.showCloneOutletProgress.showProgress && (
          <CloneOutletModal
            showModal={this.props.showCloneOutletProgress.showProgress}
            outlet={this.props.showCloneOutletProgress.outlet}
            updateCloningProgress={this.props.updateCloningProgress}
          />
        )}
      </PageWrapper>
    );
  }

  _onHideModal = () => {
    this.props.dispatch(hidePaymentGatewayError());
  };
}

List.propTypes = {
  dispatch: PropTypes.func,
};

function mapStateToProps(state) {
  const {
    outletPrice,
    showPaymentGatewayErrorModal,
    showCloneOutletProgress,
    showCloneOutletNotification,
    cloneResult,
    cloneOutletSubmit,
  } = state.outletPages.list;
  const { business } = state.moka.user;
  const { billingNotification } = state;
  return {
    data: {
      isDirtyForm: isDirty('outlet')(state),
      confirmAction: state.confirmAction,
      outletPages: {
        list: state.outletPages.list,
      },
      loadingSpinner: state.loadingSpinner,
      outletCount: getFormValues('AddOutletModalForm')(state),
      outletPrice,
      showPaymentGatewayErrorModal,
    },
    billingNotification,
    showCloneOutletProgress,
    showCloneOutletNotification,
    cloneResult,
    businessId: business.id,
    cloneOutletSubmit,
  };
}

const connected = connect(mapStateToProps)(List);

const mapFlagToProps = flags => {
  return {
    hasCloneOutletFeatureFlag: flags.cloneOutletFeatureFlag,
    enableCmpIndicators: flags.enableCmpIndicators,
  };
};

export default withFeatureFlag(mapFlagToProps)(connected);
